// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-overflow[data-v-56ddde06] {\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
